import { axios } from '../../../lib/axios';
import { Post } from '../types';

export const getPosts = async () => {
  return await axios.get<Post[]>('/posts');
};